import { render, staticRenderFns } from "./DashTenant.vue?vue&type=template&id=e47c2ea6&"
import script from "./DashTenant.vue?vue&type=script&lang=js&"
export * from "./DashTenant.vue?vue&type=script&lang=js&"
import style0 from "./DashTenant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports